/**
 * Banner page entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export const TYPE = {
    commercial_large: {
        title_key: 'commercial_large',
    },
    commercial_small: {
        title_key: 'commercial_small',
    },
    topper: {
        title_key: 'topper',
    },
    special_newsletter: {
        title_key: 'special_newsletter',
    },
    author_tip: {
        title_key: 'author_tip',
    },
    celebrity_tip: {
        title_key: 'celebrity_tip',
    },
    content_tip: {
        title_key: 'content_tip',
    },
    infobox_event_submit: {
        title_key: 'infobox_event_submit',
    },
    infobox_event_publish: {
        title_key: 'infobox_event_publish',
    },
    reduction: {
        title_key: 'reduction',
    },
};

export const CONTEXT = {
    event: {
        title_key: 'agenda',
        cls: 'event',
    },
    magazin: {
        title_key: 'magazin',
        cls: 'magazin',
    },
    address: {
        title_key: 'kulturplatz',
        cls: 'address',
    },
};

export const LOCATION = {
    main_page: { title_key: 'frontpage' },
    magazin_index: { title_key: 'magazin_index' },
    magazin_detail: { title_key: 'magazin_detail' },
    event_index: { title_key: 'agenda_index' },
    event_detail: { title_key: 'agenda_detail' },
    address_index: { title_key: 'address_index' },
    address_detail: { title_key: 'address_detail' },
    service: { title_key: 'service' },
    kiosk: { title_key: 'kiosk' },
};

export class Banner extends BaseModel {
    defaults() {
        return {
            id: null,
            type: null,
            icon: null,
            featured_image_id: null,
            featured_img_crop_config: null,
            count: null,
            text: null,
            weight: null,
            link: null,
            publish_from: null,
            publish_to: null,
            location_idents: null,
            title: null,
            commercial: null,
            contact_person: null,
            comment: null,
            created: null,
            modified: null,
            is_placeholder: null,
            context: null,
            relative_image_path: null,
            relative_thumb_path: null,
            animated: null,
            display_order: null,

            // view props:
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            is_published: Boolean,
            is_placeholder: Boolean,
            commercial: Boolean,
            created: dayjs,
            modified: dayjs,
            publish_from: dayjs,
            publish_to: dayjs,
        };
    }

    entityName() {
        return 'Banner';
    }
}

export class BannerCollection extends BaseCollection {
    options() {
        return {
            model: Banner,
        };
    }

    entityName() {
        return 'Banner';
    }
}
